import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateMetrics } from '@/services/universityService';
import { toast } from "sonner";

export function useMetricUpdates() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateMetrics,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['rankings'] });
      queryClient.invalidateQueries({ queryKey: ['depaul'] });
      toast.success("Rankings updated successfully");
    },
    onError: (error) => {
      toast.error("Failed to update rankings");
      console.error("Update error:", error);
    }
  });
}